// Module
var code = "<organization\n  organization-id=\"vm.organization.id\"\n  file-id=\"vm.organization.logoImageId\"\n  folder-id=\"vm.organization.folderId\"\n/>\n";
// Exports
module.exports = code;